import devicesTableReducer from './slice';

export default devicesTableReducer;

export * from './data';
export * from './selectors';
export * from './slice';
export * from './types';
